import { atom } from 'recoil';

import { User } from '../models';

export const userState = atom<User>({
  key: 'user',
  default: {},
});
